import {
  useDispatch as _useDispatch,
  useSelector as _useSelector,
} from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';

import { AppDispatch, RootState } from '@/redux';

export const useAppDispatch = () => _useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = _useSelector;
